export default __webpack_public_path__ + "static/media/zh.94a91784.svg";